export const licensingConstants = {
  VALIDATE_LICENSE_REQUEST: 'VALIDATE_LICENSE_REQUEST',
  VALIDATE_LICENSE_SUCCESS: 'VALIDATE_LICENSE_SUCCESS',
  VALIDATE_LICENSE_FAILURE: 'VALIDATE_LICENSE_FAILURE',

  GET_LICENSE_REQUEST: 'GET_LICENSE_REQUEST',
  GET_LICENSE_SUCCESS: 'GET_LICENSE_SUCCESS',
  GET_LICENSE_FAILURE: 'GET_LICENSE_FAILURE',

  GENERATE_PHRASE_REQUEST: 'GENERATE_PHRASE_REQUEST',
  GENERATE_PHRASE_SUCCESS: 'GENERATE_PHRASE_SUCCESS',
  GENERATE_PHRASE_FAILURE: 'GENERATE_PHRASE_FAILURE',

  UPLOAD_LICENSE_REQUEST: 'UPLOAD_LICENSE_REQUEST',
  UPLOAD_LICENSE_SUCCESS: 'UPLOAD_LICENSE_SUCCESS',
  UPLOAD_LICENSE_FAILURE: 'UPLOAD_LICENSE_FAILURE',

  READ_KEY_REQUEST: 'READ_KEY_REQUEST',
  READ_KEY_SUCCESS: 'READ_KEY_SUCCESS',
  READ_KEY_FAILURE: 'READ_KEY_FAILURE'
};
